module.exports = __webpack_public_path__ + "db8b91e9721b141cf43250fef6074ef1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/beach-bungalow-empty.png
// module id = 301
// module chunks = 0